<div class="main_plus_side">
  <div class="sidesheet_temp mat-elevation-z2">
    <p *ngIf="true">
      <calendar-widget (onSelectDate)="changeDate($event)"
                       [selectedDate]="fechaCalendar"
                       [selectedDates]="[fechaCalendar]"
                       [initialCalendarDate]="fechaInicioCalendar"
                       [endCalendarDate]="fechaFinCalendar"></calendar-widget>
    </p>
  </div>
  <div class="main_sheet">
    <div style="display: flex; align-items: baseline;">
      <h2 style="display: inline-flex">Novedades de transporte para el día {{fechaCalendar.mDate | momentFormat: 'MMMM DD [de] YYYY'}}</h2>
      <span class="spacer"></span>
      <small style="display: inline-flex;">Generado el {{fechaGenerado | momentFormat: 'DD [de] MMMM [de] YYYY [a las] hh:mm'}}</small>
    </div>
    <br>
    <mat-form-field class="full-width">
      <mat-label>Filtro</mat-label>
      <input matInput autocomplete="off" [formControl]="filterInputCtrl">
      <mat-hint>Filtre sobre el campo <i>alumno</i></mat-hint>
    </mat-form-field>
    <br>
    <br>
    <div class="full-width mat-elevation-z8">
      <table mat-table class="full-width" [dataSource]="filteredStudentList | async">
        <ng-container matColumnDef="curso">
          <th mat-header-cell *matHeaderCellDef>Curso</th>
          <td mat-cell *matCellDef="let element">{{element.curso.nombre}}</td>
        </ng-container>
        <ng-container matColumnDef="codigo">
          <th mat-header-cell *matHeaderCellDef>Código</th>
          <td mat-cell *matCellDef="let element">{{element.alumno.codigo}}</td>
        </ng-container>
        <ng-container matColumnDef="alumno">
          <th mat-header-cell *matHeaderCellDef>Alumno</th>
          <td mat-cell *matCellDef="let element">{{element.alumno.apellidosNombres}}</td>
        </ng-container>
        <ng-container matColumnDef="novedades">
          <th mat-header-cell *matHeaderCellDef>Novedades</th>
          <td mat-cell *matCellDef="let element"></td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columns"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>
      </table>
    </div>
  </div>
</div>
